export const UPDATE_LMS_COURSE_REQUEST = '@lmsCourse/LMS_UPDATE_COURSE_REQUEST';
export const UPDATE_LMS_COURSE_SUCCESS = '@lmsCourse/LMS_UPDATE_COURSE_SUCCESS';
export const UPDATE_LMS_COURSE_FAILURE = '@lmsCourse/LMS_UPDATE_COURSE_FAILURE';
